import facepaint from 'facepaint';
import { fontSizes, breakpoints, pageWidth } from './variables';

const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`));

const fontSize = size => `${size / fontSizes.default}rem`;

const letterSpacing = size => `${size / 1000}em`;

const lineHeight = (size, fontSize) => `${size / fontSize}`;

const rWidth = width => `calc(100vw * (${width} / ${pageWidth}))`;

export { mq, fontSize, letterSpacing, lineHeight, rWidth };



// WEBPACK FOOTER //
// ./src/css/utilities.js